var React = require('react');

function Refresh2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":"1"},[React.createElement("path",{"fill":"#242D3F","d":"M18.82 8.016L22.737 12h-2.95c0 2.219-.767 4.11-2.303 5.672-1.536 1.562-3.38 2.344-5.53 2.344-1.505 0-2.903-.422-4.193-1.266l1.428-1.453c.83.469 1.751.703 2.765.703 1.628 0 3.018-.586 4.17-1.758 1.152-1.172 1.728-2.586 1.728-4.242h-2.949l3.917-3.984zM6.056 12h2.949l-3.963 3.984L1.125 12h2.95c0-2.219.767-4.11 2.303-5.672 1.536-1.562 3.395-2.344 5.576-2.344 1.505 0 2.903.422 4.193 1.266l-1.474 1.453c-.83-.469-1.736-.703-2.72-.703-1.627 0-3.017.586-4.17 1.758C6.633 8.93 6.057 10.344 6.057 12z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Refresh2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Refresh2;

Refresh2.default = Refresh2;
